import React from 'react';
import Navbar from '../../components/Navbar2';
import Contact from '../../components/Contact';
import './index.css';

const InvestOwnPage = () => {
  return (
    <div className="invest-page">
      <Navbar />

      {/* Hero Section */}
      <div className="invest-hero">
        <div className="invest-hero-overlay" />
        <div className="invest-hero-content">
          <p className="invest-hero-label">Smart Investment</p>
          <h1 className="invest-hero-title">
            Innovative Ownership &
            <br />
            Investment Opportunities
          </h1>
          <p className="invest-hero-sub">
            Experience a revolutionary model where you can co-own a Luxe Unbounded property and share in its monthly rental income. Discover the future of luxury investment.
          </p>
        </div>
      </div>

      {/* Intro Section */}
      <div className="invest-intro-section">
        <div className="invest-intro-inner">
          <p className="invest-intro-label">Our Offerings</p>
          <h2 className="invest-intro-title">A New Era of Luxury Investment</h2>
          <p className="invest-intro-text">
            Co-own exceptional properties with Luxe Unbounded.
            Structured as true participation through CCPS.
            Built on hospitality income and real estate growth.
            Designed for long-term value—not periodic returns.
          </p>
          <ul className="invest-list">
            <li>
              <strong>Partial Ownership & Rental Sharing:</strong> Secure a steady return on your investment.
            </li>
            <li>
              <strong>Digital Twin & NFT Experience:</strong> Explore virtual walkthroughs and invest in exclusive digital assets.
            </li>
            <li>
              <strong>Blockchain-Based Ownership:</strong> Complete transparency and security with cutting-edge blockchain tracking.
            </li>
          </ul>
        </div>
      </div>

      {/* Investment Models */}
      <div className="invest-sections-wrap">
        {/* Model 1 - Partial Ownership */}
        <div className="invest-hs-section">
          <div className="invest-hs-text">
            <p className="invest-hs-label">Model 01</p>
            <h2 className="invest-hs-title">Partial Ownership</h2>
            <p className="invest-hs-desc">
              Not just a stay - something you belong to.
              Co-own a Luxe Unbounded residence, designed for intimate, recurring escapes.
              Structured participation through CCPS aligns you with the asset itself.
              Where time spent and value created quietly grow together.
            </p>
            <p className="invest-hs-desc">
              All the joys of ownership, without the responsibilities.
              Every detail is effortlessly managed by Luxe Unbounded.
            </p>
          </div>
          <div className="invest-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla8.webp?alt=media&token=f22a0cd8-03f2-485e-8221-b0baed029f43"
              alt="Partial Ownership"
            />
          </div>
        </div>

        {/* Model 2 - Partner Property */}
        <div className="invest-hs-section">
          <div className="invest-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla9.webp?alt=media&token=41541a8d-0dbf-4abf-86f8-284675df65ed"
              alt="Partner Property"
            />
          </div>
          <div className="invest-hs-text">
            <p className="invest-hs-label">Model 02</p>
            <h2 className="invest-hs-title">Partner Property</h2>
            <p className="invest-hs-desc">
              For community members who already own a property and wish to integrate it into our Luxe Unbounded ecosystem, our Pre-Existing Partner Properties option is the ideal solution. Under this model, you maintain full ownership while benefiting from our expert management services — ranging from property upkeep and premium guest experiences to innovative digital tools such as virtual walkthroughs and blockchain tracking.
            </p>
          </div>
        </div>
      </div>

      <Contact />
    </div>
  );
};

export default InvestOwnPage;
